import React, { useEffect, useRef } from "react";
import { caseStatusBgColor, caseStatusLabel } from "../../../../constants";

function CaseStatusCell(props) {
  const { caseStatus, width, highlight = false } = props;

  const bgColor = caseStatusBgColor[caseStatus] || caseStatusBgColor.default;

  const ref = useRef()

  useEffect(() => {
    if (highlight) {
      ref?.current?.scrollIntoView({ block: "nearest", behavior: "smooth" })
    }
  }, [highlight]);

  return (
    <div
      ref={ref}
      className={`h-full border border-solid border-[#B3B3B3] px-2 py-4 ${highlight && 'bg-yellow-100'}`}
      style={{
        width: width,
        textAlign: "center",
        backgroundColor: bgColor,
      }}
    >
      <p className="text-sm leading-[18px] tracking-[.2em] truncate">
        {caseStatusLabel[caseStatus]}
      </p>
    </div>
  );
}

export default CaseStatusCell;
